import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Dialog.css';

// Registration type selection dialog component
const RegisterTypeDialog = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleEmployeeRegister = () => {
    window.location.href = 'https://tapgo.co.kr/user/register';
  };

  const handleAdminRegister = () => {
    window.location.href = 'https://tapgo.co.kr/register';
  };
  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-container" style={{ width: '400px', height: 'auto', padding: '20px', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '10px', textAlign: 'center' }}>
          <h2 style={{ fontSize: '24px', fontWeight: 'bold', margin: '10px 0 20px 0' }}>회원가입</h2>
          
          <div style={{ margin: '20px 0', padding: '0 10px', textAlign: 'center' }}>
            <p style={{ fontSize: '16px', lineHeight: '1.5' }}>
              회원가입을 시작하기 전에, 아래 중<br />해당되는 유형을 선택해주세요.
            </p>
          </div>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '30px' }}>
            <button 
              style={{ 
                backgroundColor: '#FF6F0F', 
                color: 'white', 
                padding: '15px 0', 
                borderRadius: '5px',
                border: 'none',
                cursor: 'pointer',
                fontSize: '16px',
                width: '100%',
                fontWeight: 'bold'
              }}
              onClick={handleEmployeeRegister}
            >
              직원으로 가입
            </button>
            
            <button 
              style={{ 
                backgroundColor: '#FF6F0F', 
                color: 'white', 
                padding: '15px 0', 
                borderRadius: '5px',
                border: 'none',
                cursor: 'pointer',
                fontSize: '16px',
                width: '100%',
                fontWeight: 'bold',
                marginTop: '10px'
              }}
              onClick={handleAdminRegister}
            >
              관리자로 가입
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterTypeDialog; 